import React from "react";
import { MapIllustration } from "@c4c-web/icons";

interface ICenteredMapIllustrationProps {
  isTyping: boolean;
}

export const CenteredMapIllustration: React.FC<
  ICenteredMapIllustrationProps
> = ({ isTyping }): JSX.Element => {
  return (
    <div>
      {!isTyping && (
        <div className="absolute top-[28%] flex w-full justify-center overflow-hidden ltr:left-1/2 ltr:-translate-x-1/2 rtl:right-1/2  rtl:translate-x-1/2">
          <MapIllustration
            className="stroke-0"
            height={276}
            size="custom"
            width={402}
          />
        </div>
      )}
    </div>
  );
};
